import React from "react";
import { type WalletListProps } from "utils/types/wallet.type";

export default function WalletList({
  wallets,
  isLoading,
  selectedWalletId,
  onWalletSelect,
}: WalletListProps) {
  if (isLoading) {
    return (
      <div className="mb-4">
        <h3 className="text-black-900 text-lg font-semibold mb-3">
          User Wallets
        </h3>
        <p className="text-black-700 text-sm">Loading wallets...</p>
      </div>
    );
  }

  if (wallets.length === 0) {
    return (
      <div className="mb-4">
        <h3 className="text-black-900 text-lg font-semibold mb-3">
          User Wallets
        </h3>
        <p className="text-black-700 text-sm">No wallets found</p>
      </div>
    );
  }

  return (
    <div className="mb-4">
      <h3 className="text-black-900 text-lg font-semibold mb-3">
        User Wallets
      </h3>
      <div className="flex flex-wrap gap-2">
        {wallets.map((wallet) => (
          <button
            key={wallet._id}
            onClick={(e) => {
              e.stopPropagation();
              onWalletSelect(wallet._id);
            }}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
              selectedWalletId === wallet._id
                ? "bg-cyan-800 text-white"
                : "bg-white text-black-900 border border-gray-300 hover:bg-gray-100"
            }`}
          >
            {wallet.name}
            {wallet.is_selected && (
              <span className="ml-2 text-xs">(Selected)</span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}

